import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { Icon, USER_INTERFACE_TICK_DONE } from '@bwoty-web/styleguide';
import './cruiseListCardBody.scss';
import './cruiseListCardLink.scss';

const CruiseListCardBody = ({
  bodyContent: {
    uspList,
    texts,
  },
  href,
  onSelect,
}) => {

  const getTextPoint = (text) => {
    return (
      <div className="iw-cruise-list-card-body__text-point">
        <Icon
          path={USER_INTERFACE_TICK_DONE}
          className="iw-cruise-list-card-body__text-point-icon"
          size="xxs"
        />
        {text}
      </div>
    );
  }

  return (
    <div className="iw-cruise-list-card-body-container">
      {(href || onSelect) && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
        <a
          href={href}
          onClick={onSelect}
          rel="nofollow"
          className="iw-cruise-list-card__link"
        />
      )}
      <div className="iw-cruise-list-card-body-content">
        {uspList && (
          <ul className="iw-cruise-list-card-body__usp-list">
            {uspList.map(usp => (
              <li 
                className="iw-cruise-list-card-body__usp-list-item"
                key={uniqid('uspItem-')}
              >
                {usp}
              </li>
            ))}
          </ul>
        )}
        {(texts?.hotelNightsText || texts?.mealsText) && (
        <div className="iw-cruise-list-card-body__text-points">
          {texts?.hotelNightsText && getTextPoint(texts?.hotelNightsText)}
          {texts?.mealsText && getTextPoint(texts?.mealsText)}
        </div>
        )}
      </div>
    </div>
  );
};

CruiseListCardBody.propTypes = {
  bodyContent: PropTypes.shape({
    uspList: PropTypes.arrayOf(PropTypes.string),
    texts: PropTypes.shape({
      hotelNightsText: PropTypes.string,
      mealsText: PropTypes.string,
    }),
  }),
  href: PropTypes.string,
  onSelect: PropTypes.func,
};

CruiseListCardBody.defaultProps = {
  bodyContent: null,
  href: null,
  onSelect: null,
};

export default CruiseListCardBody;
